import { use } from "react";
import { Types } from "../actions/actionTypes";
import initialState from "../store/initial-state";

export const volatileDataReducer = (state = initialState.volatileDataReducer, action) => {
    switch (action.type) {
        case Types.VENTILATOR_PATIENT_HISTORY_TIME_DATA: {
            // console.log("VENTILATOR_PATIENT_HISTORY_TIME_DATA reducer payload---->", action?.payload)
            let bedId = action?.payload?.bedId;
            let duration = action?.payload?.duration;
            let startDate = action?.payload?.startDate;
            let startTime = action?.payload?.startTime;
            let endDate = action?.payload?.endDate;
            let endTime = action?.payload?.endTime;
            let startDateTime = action?.payload?.startDateTime;
            let endDateTime = action?.payload?.endDateTime;


            if (!bedId || !duration || !startDate || !startTime
                || !endDate || !endTime || !startDateTime || !endDateTime) {

                // console.log("hiii")
                return {
                    ...state
                };

            }
            let ventilatorPatientHistoryTimeData = state.ventilatorPatientHistoryTimeData;
            // console.log("ventilatorPatientHistoryTimeData previous state-------->", ventilatorPatientHistoryTimeData)

            ventilatorPatientHistoryTimeData[bedId] = {
                duration: duration,
                startDate: startDate,
                startTime: startTime,
                endDate: endDate,
                endTime: endTime,
                startDateTime: startDateTime,
                endDateTime: endDateTime
            }
            // console.log("reducer final packet-------->", ventilatorPatientHistoryTimeData)

            //Clear Patient history API Data
            let ventilatorPatientHistoryGraphApiData = state.ventilatorPatientHistoryGraphApiData;
            ventilatorPatientHistoryGraphApiData[bedId] = {
                isLoading: true,
                data: {}
            }

            //Clear Patient history Cursor Data
            let ventilatorPatientHistoryCursorData = state.ventilatorPatientHistoryCursorData;
            ventilatorPatientHistoryCursorData[bedId] = {
                isLoading: true,
                cursorData: {}
            }

            //Clear Current Cursor Time Data
            let ventilatorPatientHistoryCurrentCursorTime = state.ventilatorPatientHistoryCurrentCursorTime;
            ventilatorPatientHistoryCurrentCursorTime[bedId] = {
                currentCursorTime: null,
            }

            //Clear Patient Mode AP Data
            let ventilatorPatientHistoryPatientModeAPData = state.ventilatorPatientHistoryPatientModeAPData;
            ventilatorPatientHistoryPatientModeAPData[bedId] = {
                isLoading: true,
                patientModeApdata: {}
            }

            //Clear Event History Data
            let ventilatorPatientHistoryEventHistoryData = state.ventilatorPatientHistoryEventHistoryData
            ventilatorPatientHistoryEventHistoryData[bedId] = {
                isLoading: true,
                eventHistoryData: {}
            }

            //Clear Live Alarm History Data
            let ventilatorPatientHistoryLiveAlarmHistoryData = state.ventilatorPatientHistoryLiveAlarmHistoryData
            ventilatorPatientHistoryLiveAlarmHistoryData[bedId] = {
                isLoading: true,
                liveAlarmHistory: {}
            }

            //Clear Additional Features History Data
            let ventilatorPatientHistoryAdditionalFeaturesData = state.ventilatorPatientHistoryAdditionalFeaturesData
            ventilatorPatientHistoryAdditionalFeaturesData[bedId] = {
                isLoading: true,
                additionalFeatures: []
            }

            return {
                ...state,
                ventilatorPatientHistoryTimeData: { ...ventilatorPatientHistoryTimeData },
                ventilatorPatientHistoryGraphApiData: { ...ventilatorPatientHistoryGraphApiData },
                ventilatorPatientHistoryCursorData: { ...ventilatorPatientHistoryCursorData },
                ventilatorPatientHistoryCurrentCursorTime: { ...ventilatorPatientHistoryCurrentCursorTime },
                ventilatorPatientHistoryPatientModeAPData: { ...ventilatorPatientHistoryPatientModeAPData },
                ventilatorPatientHistoryEventHistoryData: { ...ventilatorPatientHistoryEventHistoryData },
                ventilatorPatientHistoryLiveAlarmHistoryData: { ...ventilatorPatientHistoryLiveAlarmHistoryData },
                ventilatorPatientHistoryAdditionalFeaturesData:{...ventilatorPatientHistoryAdditionalFeaturesData}

            }
        };


        case Types.VENTILATOR_PATIENT_HISTORY_GRAPH_API_DATA: {
            // console.log("VENTILATOR_PATIENT_HISTORY_GRAPH_API_DATA reducer payload---->", action?.payload)
            let bedId = action?.payload?.bedId;
            let isLoading = action?.payload?.isLoading;
            let data = action?.payload?.data;

            if (typeof isLoading !== "boolean" || typeof data !== "object" || !bedId) {
                return {
                    ...state
                };
            }

            // console.log("Setting data in VENTILATOR_PATIENT_HISTORY_GRAPH_API_DATA")

            let ventilatorPatientHistoryGraphApiData = state.ventilatorPatientHistoryGraphApiData;
            ventilatorPatientHistoryGraphApiData[bedId] = {
                isLoading: isLoading,
                data: data
            }
            // console.log("Final obj in VENTILATOR_PATIENT_HISTORY_GRAPH_API_DATA", ventilatorPatientHistoryGraphApiData)
            return {
                ...state,
                ventilatorPatientHistoryGraphApiData: { ...ventilatorPatientHistoryGraphApiData }

            }
        };

        case Types.VENTILATOR_PATIENT_HISTORY_CURSOR_DATA: {
            // console.log("VENTILATOR_PATIENT_HISTORY_CURSOR_DATA reducer payload---->", action?.payload)
            let bedId = action?.payload?.bedId;
            let isLoading = action?.payload?.isLoading;
            let cursorData = action?.payload?.cursorData;

            if (typeof isLoading !== "boolean" || typeof cursorData !== "object" || !bedId) {
                return {
                    ...state
                };
            }

            // console.log("Setting data in VENTILATOR_PATIENT_HISTORY_CURSOR_DATA")

            let ventilatorPatientHistoryCursorData = state.ventilatorPatientHistoryCursorData;
            ventilatorPatientHistoryCursorData[bedId] = {
                isLoading: isLoading,
                cursorData: cursorData
            }
            // console.log("Final obj in VENTILATOR_PATIENT_HISTORY_CURSOR_DATA", ventilatorPatientHistoryCursorData)
            return {
                ...state,
                ventilatorPatientHistoryCursorData: { ...ventilatorPatientHistoryCursorData }

            }
        }

        case Types.VENTILATOR_PATIENT_HISTORY_CURRENT_CURSOR_TIME: {
            // console.log("VENTILATOR_PATIENT_HISTORY_CURRENT_CURSOR_TIME reducer payload---->", action?.payload)
            let bedId = action?.payload?.bedId;
            let currentCursorTime = action?.payload?.currentCursorTime;


            if (!bedId || !currentCursorTime) {
                return {
                    ...state
                };
            }

            let ventilatorPatientHistoryCurrentCursorTime = state.ventilatorPatientHistoryCurrentCursorTime;

            ventilatorPatientHistoryCurrentCursorTime[bedId] = { currentCursorTime: currentCursorTime };

            return {
                ...state,
                ventilatorPatientHistoryCurrentCursorTime: { ...ventilatorPatientHistoryCurrentCursorTime }
            }
        }

        case Types.VENTILATOR_PATIENT_HISTORY_PATIENT_MODE_AP_DATA: {
            // console.log("VENTILATOR_PATIENT_HISTORY_PATIENT_MODE_AP_DATA reducer payload---->", action?.payload)
            let bedId = action?.payload?.bedId;
            let isLoading = action?.payload?.isLoading;
            let patientModeApdata = action?.payload?.patientModeApdata;

            if (typeof isLoading !== "boolean" || typeof patientModeApdata !== "object" || !bedId) {
                return {
                    ...state
                };
            }

            let ventilatorPatientHistoryPatientModeAPData = state.ventilatorPatientHistoryPatientModeAPData;
            ventilatorPatientHistoryPatientModeAPData[bedId] = {
                isLoading: isLoading,
                patientModeApdata: patientModeApdata
            }
            // console.log("Final obj in VENTILATOR_PATIENT_HISTORY_PATIENT_MODE_AP_DATA", ventilatorPatientHistoryPatientModeAPData)
            return {
                ...state,
                ventilatorPatientHistoryPatientModeAPData: { ...ventilatorPatientHistoryPatientModeAPData }

            }
        }

        case Types.VENTILATOR_PATIENT_HISTORY_EVENT_HISTORY_DATA: {
            // console.log("VENTILATOR_PATIENT_HISTORY_EVENT_HISTORY_DATA reducer payload---->", action?.payload)
            let bedId = action?.payload?.bedId;
            let isLoading = action?.payload?.isLoading;
            let eventHistoryData = action?.payload?.eventHistoryData;

            if (typeof isLoading !== "boolean" || !bedId || typeof eventHistoryData !== "object") {
                return {
                    ...state
                };
            }

            let ventilatorPatientHistoryEventHistoryData = state.ventilatorPatientHistoryEventHistoryData;
            ventilatorPatientHistoryEventHistoryData[bedId] = {
                isLoading: isLoading,
                eventHistoryData: eventHistoryData
            }
            // console.log("Final obj in VENTILATOR_PATIENT_HISTORY_EVENT_HISTORY_DATA", ventilatorPatientHistoryEventHistoryData)
            return {
                ...state,
                ventilatorPatientHistoryEventHistoryData: { ...ventilatorPatientHistoryEventHistoryData }

            }
        }

        case Types.VENTILATOR_PATIENT_HISTORY_LIVE_ALARM_HISTORY_DATA: {
            // console.log("VENTILATOR_PATIENT_HISTORY_LIVE_ALARM_HISTORY_DATA reducer payload---->", action?.payload)
            let bedId = action?.payload?.bedId;
            let isLoading = action?.payload?.isLoading;
            let liveAlarmHistory = action?.payload?.liveAlarmHistory;

            if (typeof isLoading !== "boolean" || !liveAlarmHistory || !bedId) {
                return {
                    ...state
                };
            }

            let ventilatorPatientHistoryLiveAlarmHistoryData = state.ventilatorPatientHistoryLiveAlarmHistoryData;
            ventilatorPatientHistoryLiveAlarmHistoryData[bedId] = {
                isLoading: isLoading,
                liveAlarmHistory: liveAlarmHistory
            }
            // console.log("Final obj in VENTILATOR_PATIENT_HISTORY_LIVE_ALARM_HISTORY_DATA", ventilatorPatientHistoryLiveAlarmHistoryData)
            return {
                ...state,
                ventilatorPatientHistoryLiveAlarmHistoryData: { ...ventilatorPatientHistoryLiveAlarmHistoryData }

            }
        }

        case Types.VENTILATOR_PATIENT_HISTORY_ADDITIONAL_FEATURES_DATA: {
            // console.log("VENTILATOR_PATIENT_HISTORY_ADDITIONAL_FEATURES_DATA reducer payload---->", action?.payload)
            let bedId = action?.payload?.bedId;
            let isLoading = action?.payload?.isLoading;
            let additionalFeatures = action?.payload?.additionalFeatures;

            if (typeof isLoading !== "boolean" || !Array.isArray(additionalFeatures) || !bedId) {
                return {
                    ...state
                };
            }

            let ventilatorPatientHistoryAdditionalFeaturesData = state.ventilatorPatientHistoryAdditionalFeaturesData;
            ventilatorPatientHistoryAdditionalFeaturesData[bedId] = {
                isLoading: isLoading,
                additionalFeatures: additionalFeatures
            }
            // console.log("Final obj in VENTILATOR_PATIENT_HISTORY_ADDITIONAL_FEATURES_DATA", ventilatorPatientHistoryAdditionalFeaturesData)
            return {
                ...state,
                ventilatorPatientHistoryAdditionalFeaturesData: { ...ventilatorPatientHistoryAdditionalFeaturesData }

            }
        }

        default:
            return state;
    }



}


